const sizes = {
  // global sizes
  base: 10,
  font: 14,
  border: 15,
  padding: 15,
  margin: 15,

  // font sizes
  h1: 48,
  h2: 36,
  h3: 28,
  h4: 24,
  title: 24,
  subTitle: 22,
  header: 28,
  subHeader: 26,
  body: 16,
  caption: 12,
  small: 12,
  button: 24,

  marginHorizontal: 10,
  marginVertical: 10,
  section: 25,
  baseMargin: 10,
  doubleBaseMargin: 20,
  smallMargin: 5,
  doubleSection: 50,
  horizontalLineHeight: 1,
  navBarHeight: 65,
  adminNavBarHeight: 65,
  inputHeight: 45,
  buttonRadius: 4,
  icons: {
    tiny: 15,
    small: 20,
    medium: 30,
    large: 45,
    xl: 50,
  },
  images: {
    small: 20,
    medium: 40,
    large: 60,
    logo: 200,
  },
  layout: {
    contentWidth: 1236,
  },
};

export default sizes;
